module.exports = __webpack_public_path__ + "static/img/menu-faq@2x.fd5483c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu-faq@2x.png
// module id = 53
// module chunks = 0